import { useForm, Controller } from 'react-hook-form';
import { Textarea } from '@acb_devel/design-system/Textarea';
import { Select, SelectItem } from '@acb_devel/design-system/Select';
import { Button } from '@acb_devel/design-system/Button';
import { Heading } from '@acb_devel/design-system/Heading';

import type { Registration } from '@services/registrations';
import type { FeedbackForm as FeedbackFormParams } from '@services/evaluations';

import styles from './FeedbackForm.module.scss';

export function FeedbackForm({
  availableRegistrationsToReview,
  defaultValues,
  onSubmit,
  onCancel,
}: {
  availableRegistrationsToReview: Registration[];
  defaultValues?: FeedbackFormParams;
  onSubmit: (data: FeedbackFormParams) => void;
  onCancel?: () => void;
}) {
  const useFormParams = { defaultValues: {} };

  if (defaultValues) {
    useFormParams.defaultValues = {
      registrationId: defaultValues.registrationId,
      name: defaultValues.name,
    };
  }

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FeedbackFormParams>(useFormParams);

  function onSubmitWrapper(event: React.FormEvent) {
    event.preventDefault();

    handleSubmit((data) => {
      onSubmit(data);
    })();
  }

  return (
    <div className={styles.feedbackForm}>
      <Heading as="p" variant="heading-2">
        Añadir feedback
      </Heading>
      <form onSubmit={onSubmitWrapper}>
        <div className={styles.feedbackForm__form}>
          <Controller
            name="registrationId"
            control={control}
            rules={{
              required: 'Selecciona un evento.',
            }}
            render={({ field }) => (
              <Select
                onValueChange={field.onChange}
                {...field}
                id="registrationId"
                label="Evento"
                placeholder="Selecciona un evento"
                className={styles.feedbackForm__select}
                errorMessage={errors.registrationId?.message}
              >
                {availableRegistrationsToReview.map((registration) => {
                  return (
                    <SelectItem
                      key={registration.id}
                      value={registration.id?.toString() ?? ''}
                    >
                      {registration.event.fullName}
                    </SelectItem>
                  );
                })}
              </Select>
            )}
          />
          <Controller
            name="name"
            control={control}
            rules={{
              required: 'El feedback es obligatorio.',
              maxLength: {
                value: 1000,
                message: 'El feedback no puede tener más de 1000 caracteres.',
              },
            }}
            render={({ field }) => (
              <Textarea
                {...field}
                id="name"
                label="¿Cómo ha sido el desempeño de este voluntario?"
                maxLength={1000}
                errorMessage={errors.name?.message}
              />
            )}
          />
          <div className={styles.feedbackForm__buttons}>
            <Button color="secondary" size="md" variant="solid" type="submit">
              Guardar
            </Button>
            <Button
              color="secondary"
              size="md"
              variant="outline"
              type="button"
              onClick={() => onCancel?.()}
            >
              Cancelar
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
}
